import {ReferralRepository} from '@raf/core/domain/ReferralRepository';
import {GraphqlRepository} from '../GraphqlRepository';

const getReferral: ReferralRepository['getReferral'] = async () => {
  return GraphqlRepository.getReferral();
};

const getReferralForShare: ReferralRepository['getReferralForShare'] = async () => {
  return GraphqlRepository.getReferralForShare();
};

export const ApiReferralRepository = {
  getReferral,
  getReferralForShare,
};
